const expandReducerChildren = (allData, payload, data, status, error, dataKey = 'AlertId', key = 'alertId') => allData.map(e => {
  if (payload[key] === e[dataKey]) {
    return {
      ...e,
      expand: {
        status,
        error,
        data
      }
    };
  }
  return { ...e };
});

export default expandReducerChildren;
